import request from "@/plugins/axiosRequest";

const xpubUrl = "/api/dashboard/v1/direct_xpub_addresses";
const ethereumUrl = "/api/dashboard/v1/direct_ethereum";
const cardanoUrl = "/api/dashboard/v1/direct_cardano";
const rippleUrl = "/api/dashboard/v1/direct_ripple";
const stellarUrl = "/api/dashboard/v1/direct_stellar";

function getUrl(type) {
  let url;
  switch (type) {
    case "XPUB":
      url = xpubUrl;
      break;
    case "ETH":
      url = ethereumUrl;
      break;
    case "ADA":
      url = cardanoUrl;
      break;
    case "XLM":
      url = stellarUrl;
      break;
    case "XRP":
      url = rippleUrl;
      break;
    default:
      url = xpubUrl;
  }
  return url;
}

export function fetchListPaymentWallet(query, type) {
  let url = getUrl(type);
  return request({
    url: url,
    method: "get",
    params: query
  });
}

export function fetchPaymentWallet(id, type) {
  let url = getUrl(type);
  return request({
    url: url,
    method: "get",
    params: { id }
  });
}

export function postNewPaymentWallet(data, type) {
  let url = getUrl(type);
  return request({
    url: url,
    method: "post",
    data
  });
}

export function deletePaymentWallet(id, type) {
  let url = getUrl(type);
  return request({
    url: `${url}/${id}`,
    method: "delete"
  });
}

export function updatePaymentWallet(data, type) {
  let url = getUrl(type);
  return request({
    url: `${url}/${data.id}`,
    method: "PUT",
    data
  });
}

export function resendConfirmationPayment(id, type) {
  let url = getUrl(type);
  return request({
    url: `${url}/${id}/resend-confirmation-token`,
    method: "POST"
  });
}

export function getAddressToCheck(id, type) {
  let url = getUrl(type);
  return request({
    url: `${url}/${id}/get-address-to-check`,
    method: "GET"
  });
}
